import { useState, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { useSentMessages } from './useSentMessages';

export const messageTypeLabels = {
  APPOINTMENT_REMINDER: 'Lembrete de consulta',
};

// As mensagens só passaram a ser registradas nesta data; meses anteriores aparecem vazios.
export const TRACKING_START_DATE = dayjs('2026-09-22');

// Orquestra a tela de mensagens enviadas: o filtro é o mês, e a API recorta do primeiro
// ao último dia dele.
export function useSentMessagesScreen() {
  const navigate = useNavigate();

  const [selectedMonth, setSelectedMonth] = useState(dayjs().startOf('month'));
  const [selectedMessage, setSelectedMessage] = useState(null);

  const startDate = useMemo(() => selectedMonth.startOf('month'), [selectedMonth]);
  const endDate = useMemo(() => selectedMonth.endOf('month'), [selectedMonth]);

  const { messages, isLoading, error, refetch } = useSentMessages({ startDate, endDate });

  const isBeforeTrackingStart = selectedMonth.isBefore(TRACKING_START_DATE.startOf('month'));

  const changeSelectedMonth = useCallback(
    (date) => date && setSelectedMonth(date.startOf('month')),
    [],
  );

  // Só o lembrete de consulta tem uma tela de origem para abrir.
  const openReference = useCallback(
    (message) => {
      if (message.type === 'APPOINTMENT_REMINDER' && message.referenceId) {
        navigate(`/appointment/${message.referenceId}`);
      }
    },
    [navigate],
  );

  return {
    isLoading,
    error: error ? String(error) : null,
    refetch,
    selectedMonth,
    setSelectedMonth: changeSelectedMonth,
    messages,
    isBeforeTrackingStart,
    selectedMessage,
    openMessage: setSelectedMessage,
    closeMessage: () => setSelectedMessage(null),
    openReference,
  };
}
